import { render, staticRenderFns } from "./ViewerBlockInfoContent.vue?vue&type=template&id=03e45d4b&scoped=true"
import script from "./ViewerBlockInfoContent.vue?vue&type=script&lang=js"
export * from "./ViewerBlockInfoContent.vue?vue&type=script&lang=js"
import style0 from "./ViewerBlockInfoContent.vue?vue&type=style&index=0&id=03e45d4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e45d4b",
  null
  
)

export default component.exports